import { useMediaQuery, useTheme } from '@mui/material';

export const useWideScreen = () => useMediaQuery(useTheme().breakpoints.up('lg'));
